import { render, staticRenderFns } from "./feeStudentEditComponent.vue?vue&type=template&id=7038d4ac&"
import script from "./feeStudentEditComponent.vue?vue&type=script&lang=js&"
export * from "./feeStudentEditComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports